import { ReadonlyRepositoryCollectionService, Result } from '@softline/core';
import { computed, inject, Injectable } from '@angular/core';
import { Stable } from '../types/stable.model';
import { StableRepository } from '../repositories/stable.repository';
import { StableQuery } from '../types/stable-query';
import { UserInfoService } from '@softline/auth';
import { SoftAppsUserInfo } from '@softapps/core';

@Injectable()
export class StableService extends ReadonlyRepositoryCollectionService<
  Stable,
  Result<Stable[]>,
  StableQuery | undefined
> {
  private readonly userInfo = inject<UserInfoService<SoftAppsUserInfo>>(UserInfoService);

  override params = computed(() => {
    const accountid = this.userInfo.value()?.accountid;

    if (!accountid) {
      return undefined;
    }

    return { idfattener: accountid };
  });

  constructor() {
    super(inject(StableRepository));
  }

  protected override getAll(result: Result<Stable[]> | null | undefined): Stable[] {
    return result?.result as Stable[];
  }
}
